import styled from 'styled-components'
import { ViewElement } from '../CartDrawer.styles'

export const Content = styled(ViewElement)`
  padding-top: 1.8rem;
  padding-bottom: 1.8rem;
`

export const Ctas = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3rem;
`
